import { useNavigate, useLocation } from "react-router";
import CreateNewPasswordForm from "../components/CreateNewPasswordForm";
import AuthLayout from "@/modules/Auth/layout/AuthLayout";
import { changePasswordService } from "@/service/auth.service";
import { successToast } from "@/utils/toast";

const NewPasswordPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Extract token from URL if present (for password reset verification)
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");

  const handleGoBack = () => {
    navigate("/auth/signin");
  };

  const handleSubmit = async (data: { newPassword: string }) => {
    try {
      await changePasswordService(token!, data.newPassword);

      // After successful reset, you can redirect or show success message
      return Promise.resolve();
    } catch (error) {
      console.error("Error resetting password:", error);
      return Promise.reject(error);
    }
  };

  return (
    <AuthLayout>
      <CreateNewPasswordForm onGoBack={handleGoBack} onSubmit={handleSubmit} />
    </AuthLayout>
  );
};

export default NewPasswordPage;
